import React, { FC, useState } from 'react'
import { useTranslation } from 'next-i18next'
import { useUser } from '../../pylot-auth-manager/src/use-user'
import { ToastType, useUI } from '@corratech/pylot-ui/context'
import { AccountHeader } from '@corratech/pylot-account-header'
import { ErrorPage } from '@components/common/ErrorPage'
import { Button } from '@corratech/pylot-ui'
import { MarketingConsent } from '@corratech/pylot-account-newsletter'
import { useForm } from 'react-hook-form'
import { useRouter } from 'next/router'
import {
    NewsletterVariableInterface,
    useNewsletterSubscription
} from './hooks/use-newsletter-subscription'
import cn from 'classnames'
import s from '@pagestyles/Account.module.scss'

export const AccountNewsletter: FC = () => {
    const { t } = useTranslation(['account'])
    const router = useRouter()
    const { LoadingIndicator, openToast } = useUI()
    const { subscriptionChannels, loading, error } = useUser()
    const { isLoading, updateSubscription } = useNewsletterSubscription()
    const { handleSubmit } = useForm<NewsletterVariableInterface>({
        mode: 'onChange'
    })

    const [subscriptions, setSubscriptions] = useState<string[]>(
        subscriptionChannels ? subscriptionChannels.split(',') : []
    )

    const handleSubscriptionsChange = (updatedSubscriptions: string[]) => {
        setSubscriptions(updatedSubscriptions)
    }

    const onSubmit = async () => {
        try {
            const response = await updateSubscription({
                subscription_channels: subscriptions.join(',')
            })

            //handle errors
            if (response?.errors?.length) {
                openToast(
                    t('account|Something went wrong. Please try again'),
                    ToastType.Danger
                )
            }

            if (response?.data?.updateCustomerV2?.customer) {
                //redirect to dashboard on success
                router.push('/account').then(() => {
                    //handle subscribe/unsubscribe message display
                    openToast(
                        t('account|We have updated your preferences'),
                        ToastType.Success
                    )
                })
            }
        } catch (e) {
            if (e) {
                openToast(
                    t('account|Something went wrong. Please try again'),
                    ToastType.Danger
                )
            }
        }
    }

    if (loading) {
        return (
            <div className="mx-auto max-w-xs">
                <LoadingIndicator />
            </div>
        )
    }

    if (error) {
        return <ErrorPage />
    }

    const marketingConsentHolderClass = 'my-account-consent'

    return (
        <div className={cn(s['newsletter-container'])}>
            <AccountHeader title={t('account|Communications')} />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div
                    className={cn(
                        s['account-block'],
                        s['marketing-consent-block']
                    )}
                >
                    <MarketingConsent
                        title={t('account|Marketing Consent')}
                        subscriptionChannels={subscriptionChannels}
                        onSubscriptionsChange={handleSubscriptionsChange}
                        holderClass={marketingConsentHolderClass}
                    />
                </div>
                <Button disabled={isLoading} type="submit">
                    {isLoading ? t('account|saving...') : t('account|save')}
                </Button>
            </form>
        </div>
    )
}
